import React from 'react';
import { Lock } from 'lucide-react';
interface ProgressBarProps {
  currentQuestion: number;
  totalQuestions: number;
}
export function ProgressBar({
  currentQuestion,
  totalQuestions
}: ProgressBarProps) {
  return <div className="flex items-center justify-center gap-4 text-xs md:text-sm text-[#121212]/70 mb-6" data-id="element-78">
      <div className="flex items-center gap-1.5" data-id="element-79">
        <Lock className="w-3 h-3" data-id="element-80" />
        <span data-id="element-81">Tus respuestas son confidenciales</span>
      </div>
    </div>;
}